import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { Box, Skeleton, Grid } from '@mui/material';

function ListingSkeleton({bg}:{bg?:string}) {
	return (
		<FlexBox
			sx={{
				justifyContent: 'center',
				flexWrap: 'wrap',
				background: bg? bg : getColor('Gray -7'),
				padding: '16px',
				paddingTop: '30px',
				':hover': {
					zIndex: 11,
				},
			}}
		>
			{Array.apply(null, Array(15)).map((d, i) => {
				return (
					<Box
						key={i}
						sx={{
							width: 'calc(25% - 56px)',
							margin: '14px',
							borderRadius: '16px',
							overflow: 'hidden',
						}}
					>
						<Box
							sx={{
								width: '100%',
								// marginBottom: '-50%',
								position: 'relative',
								textAlign: 'center',
							}}
						>
							<Skeleton
								variant='rectangular'
								sx={{ width: 'calc(25% - 56px)', paddingTop: '300px' }}
								animation='wave'
								width={'100%'}
							/>
						</Box>
						<Box
							sx={{
								background: getColor(''),
								// mt: '12px',
								padding: '24px 24px 24px 24px',
								// paddingTop: 'calc(50% - 10px)',
								borderRadius: '8px',
							}}
						>
							<Skeleton
								variant='rectangular'
								width={'80%'}
								height={20}
								animation='pulse'
								sx={{ borderRadius: '8px' }}
							/>
							<Skeleton
								variant='rectangular'
								width={'50%'}
								height={20}
								animation='pulse'
								sx={{ margin: '16px 0', borderRadius: '8px' }}
							/>
							<Skeleton
								variant='rectangular'
								width={'30%'}
								height={20}
								animation='pulse'
								sx={{ margin: '8px 0', borderRadius: '8px' }}
							/>
							<Grid display='flex' width='100%'>
								<Skeleton
									variant='rectangular'
									width={'40%'}
									height={20}
									animation='pulse'
									sx={{ margin: '8px 0', borderRadius: '8px' }}
								/>
								<Skeleton
									variant='rectangular'
									width={'30%'}
									height={20}
									animation='pulse'
									sx={{
										margin: '8px 0',
										borderRadius: '8px',
										marginLeft: '5%',
									}}
								/>
							</Grid>
						</Box>
					</Box>
				);
			})}
		</FlexBox>
	);
}

export default ListingSkeleton;
